(function () {
  'use strict';

  if (window.CustomilyMobileStickyAtc && typeof window.CustomilyMobileStickyAtc.refresh === 'function') {
    window.CustomilyMobileStickyAtc.refresh();
    return;
  }

  var ROOT_SELECTOR = '[data-customily-mobile-sticky-atc]';
  var OPTIONS_SELECTOR = '#customily-options';
  var PREVIEW_BUTTON_SELECTOR = '#customily-preview-button';
  var CART_BUTTON_SELECTOR = '#customily-cart-btn';
  var MODAL_SELECTOR = '.customily-modal-preview-only';
  var NAME_SELECTORS = [
    '.js-customily-name input',
    '.js-customily-name textarea',
    '[name="properties[Enter Name]"]',
    '[name="properties[Name]"]'
  ];

  var PREVIEW_TIMEOUT_MS = 15000;
  var CART_TIMEOUT_MS = 20000;
  var CART_BASELINE_TIMEOUT_MS = 1200;
  var CART_VERIFY_INTERVAL_MS = 650;
  var CART_ERROR_GRACE_MS = 3000;
  var ADDED_FEEDBACK_MS = 2200;

  var state = {
    reachedCustomizer: false,
    previewSignature: null,
    previewing: false,
    adding: false,
    added: false,
    error: '',
    modalOpen: false,
    cartDrawerOpen: false,
    nativeCtaVisible: false
  };

  var currentOptions = null;
  var currentModal = null;
  var currentCartDrawer = null;
  var currentPriceContainer = null;
  var currentCartButton = null;
  var optionsIntersectionObserver = null;
  var cartButtonIntersectionObserver = null;
  var modalObserver = null;
  var cartDrawerObserver = null;
  var priceObserver = null;
  var discoveryObserver = null;
  var previewTimer = null;
  var cartTimer = null;
  var addedTimer = null;
  var renderFrame = null;
  var cartAttemptId = 0;
  var cartBaselineCount = null;
  var cartVerificationDeadline = 0;
  var cartDrawerOpenedAttemptId = 0;

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function getRoot() {
    return query(ROOT_SELECTOR);
  }

  function getOptions() {
    return query(OPTIONS_SELECTOR);
  }

  function getPreviewButton() {
    return query(PREVIEW_BUTTON_SELECTOR);
  }

  function getCartButton() {
    return query(CART_BUTTON_SELECTOR);
  }

  function getNameInput() {
    var options = getOptions();
    var index;
    var input;

    if (!options) return null;

    for (index = 0; index < NAME_SELECTORS.length; index += 1) {
      input = query(NAME_SELECTORS[index], options);
      if (input) return input;
    }

    return null;
  }

  function isNameEmpty() {
    var input = getNameInput();
    return !!input && input.value.length === 0;
  }

  function getVariantId() {
    var input =
      query('.main-product-form [name="id"]') ||
      query('.sf-prod__info [name="id"]') ||
      query('form[data-type="add-to-cart-form"] [name="id"]');

    return input ? String(input.value || '') : '';
  }

  function getFieldValue(field) {
    var type = (field.type || '').toLowerCase();

    if (type === 'checkbox' || type === 'radio') {
      return {
        checked: !!field.checked,
        value: String(field.value || '')
      };
    }

    if (type === 'file') {
      return Array.prototype.map.call(field.files || [], function (file) {
        return file.name + ':' + file.size;
      });
    }

    if (field.tagName === 'SELECT' && field.multiple) {
      return Array.prototype.filter.call(field.options, function (option) {
        return option.selected;
      }).map(function (option) {
        return option.value;
      });
    }

    return String(field.value || '');
  }

  function getCustomizationSignature() {
    var options = getOptions();
    var fields = [];

    if (options) {
      fields = Array.prototype.map.call(
        options.querySelectorAll('input:not([type="hidden"]), textarea, select'),
        function (field, index) {
          return {
            key: field.name || field.id || String(index),
            disabled: !!field.disabled,
            value: getFieldValue(field)
          };
        }
      );
    }

    return JSON.stringify({
      variantId: getVariantId(),
      fields: fields
    });
  }

  function isVisible(element) {
    var style;
    var rect;

    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;

    style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

    rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function compactPrice(price) {
    return String(price || '')
      .replace(/\s+[A-Z]{3}\s*$/, '')
      .replace(/([.,])00(?=\D*$)/, '')
      .trim();
  }

  function findCurrentPrice() {
    var selectors = [
      '.sf-prod__info .f-price-item--sale',
      '.sf-prod__info .f-price-item--regular',
      '.sf-prod__info [data-product-price]',
      '.sf-prod__info .prod__price'
    ];
    var fallback = '';
    var selectorIndex;
    var candidates;
    var candidateIndex;
    var text;

    for (selectorIndex = 0; selectorIndex < selectors.length; selectorIndex += 1) {
      candidates = document.querySelectorAll(selectors[selectorIndex]);
      for (candidateIndex = 0; candidateIndex < candidates.length; candidateIndex += 1) {
        text = (candidates[candidateIndex].textContent || '').trim();
        if (!text) continue;
        if (!fallback) fallback = text;
        if (isVisible(candidates[candidateIndex])) return text;
      }
    }

    return fallback;
  }

  function syncPrice(root) {
    var priceElement;
    var price;

    if (!root) return;

    priceElement = query('[data-customily-sticky-price]', root);
    price = findCurrentPrice() || root.getAttribute('data-initial-price') || '';

    if (priceElement && price && priceElement.textContent.trim() !== price) {
      priceElement.textContent = price;
    }
  }

  function clearTimer(timerName) {
    if (timerName === 'preview' && previewTimer) {
      window.clearTimeout(previewTimer);
      previewTimer = null;
    }

    if (timerName === 'cart' && cartTimer) {
      window.clearTimeout(cartTimer);
      cartTimer = null;
    }

    if (timerName === 'added' && addedTimer) {
      window.clearTimeout(addedTimer);
      addedTimer = null;
    }
  }

  function getCartUrl() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      typeof window.Shopify.routes.root === 'string'
        ? window.Shopify.routes.root
        : '/';

    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  function getDomCartItemCount() {
    var bubbles = document.querySelectorAll('.m-cart-count-bubble');
    var foundBubble = false;
    var index;
    var value;

    for (index = 0; index < bubbles.length; index += 1) {
      foundBubble = true;
      value = parseInt((bubbles[index].textContent || '').trim(), 10);
      if (Number.isFinite(value)) return value;
    }

    return foundBubble ? 0 : null;
  }

  function fetchCartItemCount(timeoutMs) {
    return new Promise(function (resolve, reject) {
      var settled = false;
      var timeout = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        reject(new Error('Cart verification timed out.'));
      }, timeoutMs);

      window.fetch(getCartUrl(), {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          Accept: 'application/json'
        }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to read the cart.');
        return response.json();
      }).then(function (cart) {
        var count = Number(cart && cart.item_count);

        if (!Number.isFinite(count)) {
          throw new Error('The cart response did not include an item count.');
        }

        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        resolve(count);
      }).catch(function (error) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeout);
        reject(error);
      });
    });
  }

  function dispatchThemeCartEvent(name, message) {
    var event;

    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent(name, {
        detail: {
          message: message || ''
        }
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, false, false, {
        message: message || ''
      });
    }

    window.dispatchEvent(event);
  }

  function scheduleCartVerification(attemptId, delay) {
    if (!state.adding || attemptId !== cartAttemptId) return;

    clearTimer('cart');
    cartTimer = window.setTimeout(function () {
      var deadlineReached;

      cartTimer = null;

      if (!state.adding || attemptId !== cartAttemptId) return;

      fetchCartItemCount(3500).then(function (count) {
        if (!state.adding || attemptId !== cartAttemptId) return;

        if (cartBaselineCount !== null && count > cartBaselineCount) {
          handleAddToCartCompleted();
          return;
        }

        deadlineReached = Date.now() >= cartVerificationDeadline;
        if (deadlineReached) {
          setCartError('We couldn’t add this item to the cart. Your preview and personalization are still saved—please try again.');
          return;
        }

        scheduleCartVerification(attemptId, CART_VERIFY_INTERVAL_MS);
      }).catch(function () {
        if (!state.adding || attemptId !== cartAttemptId) return;

        if (Date.now() >= cartVerificationDeadline) {
          setCartError('We couldn’t confirm that this item was added. Please check your cart before trying again.');
          return;
        }

        scheduleCartVerification(attemptId, CART_VERIFY_INTERVAL_MS);
      });
    }, delay);
  }

  function setError(message) {
    state.previewing = false;
    state.adding = false;
    state.added = false;
    state.error = message;
    cartVerificationDeadline = 0;
    clearTimer('preview');
    clearTimer('cart');
    scheduleRender();
  }

  function setCartError(message) {
    setError(message);
    dispatchThemeCartEvent('customily-theme-cart-failed', message);
  }

  function invalidatePreview() {
    var signature = getCustomizationSignature();

    if (state.previewSignature !== null && state.previewSignature !== signature) {
      state.previewSignature = null;
      state.added = false;
      clearTimer('added');
    }

    state.error = '';
    scheduleRender();
  }

  function deriveView(root) {
    var price = findCurrentPrice() || root.getAttribute('data-initial-price') || '';
    var currentSignature = getCustomizationSignature();

    if (state.adding) {
      return { state: 'adding', label: 'Adding…', disabled: true };
    }

    if (state.added) {
      return { state: 'added', label: 'Added to Cart ✓', disabled: true };
    }

    if (!state.reachedCustomizer) {
      return { state: 'customize', label: 'Customize Now', disabled: false };
    }

    if (isNameEmpty()) {
      return { state: 'name', label: 'Enter Your Name', disabled: false };
    }

    if (state.previewing) {
      return { state: 'previewing', label: 'Preparing Preview…', disabled: true };
    }

    if (state.previewSignature !== null && state.previewSignature === currentSignature) {
      return {
        state: 'cart',
        label: 'Add to Cart' + (price ? ' · ' + compactPrice(price) : ''),
        disabled: false
      };
    }

    return { state: 'preview', label: 'Preview Your Shirt', disabled: false };
  }

  function render() {
    var root = getRoot();
    var label;
    var button;
    var message;
    var ready;
    var suppressed;
    var stickyVisible;
    var view;

    renderFrame = null;

    if (!root) {
      document.documentElement.classList.remove('customily-mobile-sticky-active');
      document.documentElement.classList.remove('customily-preview-open');
      document.documentElement.classList.remove('customily-cart-drawer-open');
      ensureDiscoveryObserver();
      return;
    }

    ready = !!(getOptions() && getPreviewButton() && getCartButton());
    suppressed = ready && (state.nativeCtaVisible || state.modalOpen || state.cartDrawerOpen);
    stickyVisible = ready && !suppressed;
    root.hidden = !ready;
    root.classList.toggle('customily-mobile-sticky-atc--suppressed', suppressed);
    root.setAttribute('aria-hidden', stickyVisible ? 'false' : 'true');
    document.documentElement.classList.toggle('customily-mobile-sticky-active', ready);
    document.documentElement.classList.toggle('customily-preview-open', ready && state.modalOpen);
    document.documentElement.classList.toggle(
      'customily-cart-drawer-open',
      ready && state.cartDrawerOpen
    );

    if (!ready) {
      ensureDiscoveryObserver();
      return;
    }

    stopDiscoveryObserver();
    syncPrice(root);
    view = deriveView(root);
    button = query('[data-customily-sticky-button]', root);
    label = query('[data-customily-sticky-label]', root);
    message = query('[data-customily-sticky-message]', root);

    if (button) {
      button.dataset.state = view.state;
      button.disabled = view.disabled;
      button.setAttribute('aria-busy', view.state === 'adding' || view.state === 'previewing' ? 'true' : 'false');
    }

    if (label) label.textContent = view.label;

    if (message) {
      message.hidden = !state.error;
      message.textContent = state.error;
    }
  }

  function scheduleRender() {
    if (renderFrame !== null) return;
    renderFrame = window.requestAnimationFrame(render);
  }

  function scrollToElement(element, focusAfterScroll) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!element) return;

    element.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'center'
    });

    if (focusAfterScroll && typeof element.focus === 'function') {
      window.setTimeout(function () {
        try {
          element.focus({ preventScroll: true });
        } catch (error) {
          element.focus();
        }
      }, reduceMotion ? 0 : 350);
    }
  }

  function startPreview() {
    var previewButton = getPreviewButton();

    if (!previewButton || previewButton.disabled) {
      setError('The preview is not ready yet. Please wait a moment and try again.');
      return;
    }

    state.previewing = true;
    state.error = '';
    clearTimer('preview');
    scheduleRender();

    previewTimer = window.setTimeout(function () {
      if (!state.modalOpen) {
        setError('We couldn’t create the preview. Your personalization is still saved—please try again.');
      }
    }, PREVIEW_TIMEOUT_MS);

    previewButton.click();
  }

  function startAddToCart() {
    var cartButton = getCartButton();
    var attemptId;
    var fallbackBaseline;

    if (!cartButton || cartButton.disabled) {
      setError('Add to cart is not ready yet. Please wait a moment and try again.');
      return;
    }

    if (state.adding) return;

    if (state.previewSignature === null || state.previewSignature !== getCustomizationSignature()) {
      state.previewSignature = null;
      scheduleRender();
      return;
    }

    attemptId = ++cartAttemptId;
    fallbackBaseline = getDomCartItemCount();
    cartBaselineCount = fallbackBaseline;
    cartVerificationDeadline = Date.now() + CART_TIMEOUT_MS;
    state.adding = true;
    state.added = false;
    state.error = '';
    clearTimer('cart');
    scheduleRender();

    fetchCartItemCount(CART_BASELINE_TIMEOUT_MS).then(function (count) {
      if (!state.adding || attemptId !== cartAttemptId) return;

      cartBaselineCount = count;
      cartButton.click();

      if (state.adding && attemptId === cartAttemptId) {
        scheduleCartVerification(attemptId, 350);
      }
    }).catch(function () {
      if (!state.adding || attemptId !== cartAttemptId) return;

      cartBaselineCount = fallbackBaseline;
      cartButton.click();

      if (state.adding && attemptId === cartAttemptId) {
        scheduleCartVerification(attemptId, 350);
      }
    });
  }

  function handleStickyClick(event) {
    var button = event.target.closest && event.target.closest('[data-customily-sticky-button]');
    var mode;
    var options;
    var nameInput;

    if (!button) return;

    mode = button.dataset.state;
    state.error = '';

    if (mode === 'customize') {
      options = getOptions();
      state.reachedCustomizer = true;
      scheduleRender();
      scrollToElement(options, false);
      return;
    }

    if (mode === 'name') {
      nameInput = getNameInput();
      scrollToElement(nameInput || getOptions(), !!nameInput);
      return;
    }

    if (mode === 'preview') {
      startPreview();
      return;
    }

    if (mode === 'cart') {
      startAddToCart();
    }
  }

  function isCustomizationTarget(target) {
    return !!(
      target &&
      target.closest &&
      (
        target.closest(OPTIONS_SELECTOR) ||
        target.closest('[data-variant-picker]') ||
        target.closest('.product__variant-picker')
      )
    );
  }

  function handleFieldChange(event) {
    if (!isCustomizationTarget(event.target)) return;
    invalidatePreview();
  }

  function updateReachedCustomizer() {
    var options = getOptions();
    var rect;

    if (!options || state.reachedCustomizer) return;

    rect = options.getBoundingClientRect();
    if (rect.top <= window.innerHeight * 0.9) {
      state.reachedCustomizer = true;
      scheduleRender();
    }
  }

  function bindOptionsObserver() {
    var options = getOptions();

    if (!options || options === currentOptions) return;

    currentOptions = options;

    if (optionsIntersectionObserver) optionsIntersectionObserver.disconnect();

    if ('IntersectionObserver' in window) {
      optionsIntersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            state.reachedCustomizer = true;
            scheduleRender();
          }
        });
      }, {
        threshold: 0.05
      });
      optionsIntersectionObserver.observe(options);
    }

    updateReachedCustomizer();
  }

  function updateNativeCtaVisibility() {
    var cartButton = getCartButton();
    var rect;
    var visibleHeight;
    var minimumVisibleHeight;
    var visible;

    if (!cartButton || !isVisible(cartButton)) {
      visible = false;
    } else {
      rect = cartButton.getBoundingClientRect();
      visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      minimumVisibleHeight = Math.min(rect.height * 0.25, 20);
      visible = visibleHeight >= minimumVisibleHeight;
    }

    if (state.nativeCtaVisible !== visible) {
      state.nativeCtaVisible = visible;
      scheduleRender();
    }
  }

  function bindCartButtonObserver() {
    var cartButton = getCartButton();

    if (!cartButton) {
      currentCartButton = null;
      state.nativeCtaVisible = false;
      if (cartButtonIntersectionObserver) {
        cartButtonIntersectionObserver.disconnect();
        cartButtonIntersectionObserver = null;
      }
      return;
    }

    if (cartButton === currentCartButton) {
      updateNativeCtaVisibility();
      return;
    }

    currentCartButton = cartButton;

    if (cartButtonIntersectionObserver) {
      cartButtonIntersectionObserver.disconnect();
      cartButtonIntersectionObserver = null;
    }

    if ('IntersectionObserver' in window) {
      cartButtonIntersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== currentCartButton) return;

          state.nativeCtaVisible =
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.25;
          scheduleRender();
        });
      }, {
        threshold: [0, 0.25, 0.5, 1]
      });

      cartButtonIntersectionObserver.observe(cartButton);
    }

    updateNativeCtaVisibility();
  }

  function syncModalState() {
    var modal = query(MODAL_SELECTOR);
    var visible = isVisible(modal);

    if (visible && !state.modalOpen) {
      state.modalOpen = true;
      state.previewing = false;
      state.previewSignature = getCustomizationSignature();
      state.error = '';
      clearTimer('preview');
      scheduleRender();
    } else if (!visible && state.modalOpen) {
      state.modalOpen = false;
      scheduleRender();
    }
  }

  function bindModalObserver() {
    var modal = query(MODAL_SELECTOR);

    if (!modal || modal === currentModal) return;

    currentModal = modal;
    if (modalObserver) modalObserver.disconnect();

    modalObserver = new MutationObserver(syncModalState);
    modalObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });

    syncModalState();
  }

  function syncCartDrawerState() {
    var drawer = query('m-cart-drawer');
    var open = !!(drawer && drawer.classList.contains('m-cart-drawer--active'));

    if (open === state.cartDrawerOpen) return;
    state.cartDrawerOpen = open;
    scheduleRender();
  }

  function bindCartDrawerObserver() {
    var drawer = query('m-cart-drawer');

    if (!drawer) {
      currentCartDrawer = null;
      if (cartDrawerObserver) {
        cartDrawerObserver.disconnect();
        cartDrawerObserver = null;
      }
      syncCartDrawerState();
      return;
    }

    if (drawer === currentCartDrawer) {
      syncCartDrawerState();
      return;
    }

    currentCartDrawer = drawer;
    if (cartDrawerObserver) cartDrawerObserver.disconnect();

    cartDrawerObserver = new MutationObserver(syncCartDrawerState);
    cartDrawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden']
    });

    syncCartDrawerState();
  }

  function bindPriceObserver() {
    var priceContainer = query('.sf-prod__info .f-price');

    if (!priceContainer || priceContainer === currentPriceContainer) return;

    currentPriceContainer = priceContainer;
    if (priceObserver) priceObserver.disconnect();

    priceObserver = new MutationObserver(scheduleRender);
    priceObserver.observe(priceContainer, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function stopDiscoveryObserver() {
    if (!discoveryObserver) return;
    discoveryObserver.disconnect();
    discoveryObserver = null;
  }

  function ensureDiscoveryObserver() {
    if (discoveryObserver || !document.documentElement) return;

    discoveryObserver = new MutationObserver(function () {
      refresh();
    });

    discoveryObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function refresh() {
    bindOptionsObserver();
    bindCartButtonObserver();
    bindModalObserver();
    bindCartDrawerObserver();
    bindPriceObserver();
    updateReachedCustomizer();
    scheduleRender();
  }

  function refreshCartDrawerBeforeOpen(drawer) {
    var contentRoot = typeof drawer.querySelector === 'function'
      ? drawer.querySelector('[data-minimog-cart-items]') ||
        drawer.querySelector('.m-cart-drawer--inner')
      : null;

    if (typeof drawer.onCartDrawerUpdate !== 'function') {
      return Promise.resolve();
    }

    if (!contentRoot || typeof window.MutationObserver !== 'function') {
      drawer.onCartDrawerUpdate();
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      var finished = false;
      var settleTimer = null;
      var fallbackTimer = null;
      var observer;

      function finish() {
        if (finished) return;
        finished = true;
        observer.disconnect();
        if (settleTimer !== null) window.clearTimeout(settleTimer);
        if (fallbackTimer !== null) window.clearTimeout(fallbackTimer);
        resolve();
      }

      function scheduleFinish() {
        if (settleTimer !== null) window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(finish, 300);
      }

      observer = new window.MutationObserver(scheduleFinish);
      observer.observe(contentRoot, {
        childList: true,
        subtree: true,
        characterData: true
      });

      fallbackTimer = window.setTimeout(finish, 4000);

      try {
        drawer.onCartDrawerUpdate();
      } catch (error) {
        console.warn('Unable to refresh the cart drawer before opening it.', error);
        finish();
      }
    });
  }

  function refreshAndOpenCartDrawer(attemptId) {
    var shopify = window.Shopify;
    var themeCart = window.MinimogTheme && window.MinimogTheme.Cart;
    var drawer = query('m-cart-drawer');

    if (!attemptId || cartDrawerOpenedAttemptId === attemptId) return;
    cartDrawerOpenedAttemptId = attemptId;

    if (drawer && typeof drawer.open === 'function') {
      refreshCartDrawerBeforeOpen(drawer).then(function () {
        if (
          attemptId !== cartAttemptId ||
          cartDrawerOpenedAttemptId !== attemptId
        ) {
          return;
        }

        drawer.open();
      });
      return;
    }

    if (shopify && typeof shopify.onCartUpdate === 'function') {
      Promise.resolve(shopify.onCartUpdate(null, true)).catch(function (error) {
        console.warn('Unable to refresh the cart drawer through Shopify.onCartUpdate().', error);
      });
      return;
    }

    if (
      themeCart &&
      typeof themeCart.refreshCart === 'function' &&
      typeof themeCart.renderNewCart === 'function' &&
      typeof themeCart.openCartDrawer === 'function'
    ) {
      Promise.resolve(themeCart.refreshCart())
        .then(function () {
          return themeCart.renderNewCart();
        })
        .then(function () {
          themeCart.openCartDrawer();
        })
        .catch(function (error) {
          console.warn('Unable to refresh the theme cart drawer.', error);
        });
      return;
    }

  }

  function handlePreviewModalShow() {
    state.modalOpen = true;
    state.previewing = false;
    state.previewSignature = getCustomizationSignature();
    state.error = '';
    clearTimer('preview');
    scheduleRender();
  }

  function handlePreviewModalHide() {
    state.modalOpen = false;
    scheduleRender();
  }

  function handleRequiredError() {
    state.reachedCustomizer = true;

    if (isNameEmpty()) {
      setError('Please enter your name before previewing.');
    } else {
      setError('Please complete the required personalization before continuing.');
    }
  }

  function handleAddingToCart() {
    if (!state.adding) {
      cartAttemptId += 1;
      cartBaselineCount = getDomCartItemCount();
    }

    state.adding = true;
    state.added = false;
    state.error = '';
    cartVerificationDeadline = Date.now() + CART_TIMEOUT_MS;
    scheduleCartVerification(cartAttemptId, 350);

    scheduleRender();
  }

  function handleThemeCartRequested() {
    if (state.adding) return;
    handleAddingToCart();
  }

  function handleAddToCartCompleted() {
    if (state.added && !state.adding) return;

    state.adding = false;
    state.added = true;
    state.error = '';
    cartVerificationDeadline = 0;
    clearTimer('cart');
    clearTimer('added');
    scheduleRender();
    refreshAndOpenCartDrawer(cartAttemptId);
    dispatchThemeCartEvent('customily-theme-cart-confirmed');

    addedTimer = window.setTimeout(function () {
      state.added = false;
      scheduleRender();
    }, ADDED_FEEDBACK_MS);
  }

  function handleAddToCartError() {
    if (state.added && !state.adding) return;

    if (!state.adding) {
      cartAttemptId += 1;
      cartBaselineCount = getDomCartItemCount();
      state.adding = true;
    }

    cartVerificationDeadline = Math.min(
      cartVerificationDeadline || Date.now() + CART_ERROR_GRACE_MS,
      Date.now() + CART_ERROR_GRACE_MS
    );
    scheduleCartVerification(cartAttemptId, 150);
    scheduleRender();
  }

  document.addEventListener('click', handleStickyClick);
  document.addEventListener('input', handleFieldChange, true);
  document.addEventListener('change', handleFieldChange, true);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('scroll', function () {
    updateReachedCustomizer();
    updateNativeCtaVisibility();
  }, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });

  window.addEventListener('customily-options-loaded', refresh);
  window.addEventListener('customily-options-changed', invalidatePreview);
  window.addEventListener('customily-pricing-change', scheduleRender);
  window.addEventListener('customily-preview-modal-show', handlePreviewModalShow);
  window.addEventListener('customily-preview-modal-hide', handlePreviewModalHide);
  window.addEventListener('customily-modal-close', handlePreviewModalHide);
  window.addEventListener('customily-required-error', handleRequiredError);
  window.addEventListener('customily-starts-adding-to-cart', handleAddingToCart);
  window.addEventListener('customily-add-to-cart-completed', handleAddToCartCompleted);
  window.addEventListener('customily-add-addons-error', handleAddToCartError);
  window.addEventListener('customily-add-addond-error', handleAddToCartError);
  window.addEventListener('customily-theme-cart-requested', handleThemeCartRequested);
  window.CustomilyMobileStickyAtc = {
    refresh: refresh,
    getState: function () {
      return {
        reachedCustomizer: state.reachedCustomizer,
        previewCurrent: state.previewSignature !== null && state.previewSignature === getCustomizationSignature(),
        previewing: state.previewing,
        adding: state.adding,
        added: state.added,
        modalOpen: state.modalOpen,
        cartDrawerOpen: state.cartDrawerOpen,
        nativeCtaVisible: state.nativeCtaVisible,
        error: state.error
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  ensureDiscoveryObserver();
})();
